import Icon from '../components/Icon.vue'

Icon.register({
  'pencil-alt': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M497.9 142.1L451.8 188.2C447.1 192.9 439.5 192.9 434.8 188.2L323.8 77.2C319.1 72.5 319.1 64.9 323.8 60.2L369.9 14.1C388.6-4.6 419-4.6 437.8 14.1L497.9 74.2C516.7 92.9 516.7 123.3 497.9 142.1zM284.2 99.8L21.6 362.4 0.4 483.9C-2.5 500.3 11.8 514.5 28.2 511.7L149.7 490.4 412.3 227.8C417 223.1 417 215.5 412.3 210.8L301.3 99.8C296.5 95.1 288.9 95.1 284.2 99.8zM124.1 339.9C118.6 334.4 118.6 325.6 124.1 320.1L278.1 166.1C283.6 160.6 292.4 160.6 297.9 166.1S303.4 180.4 297.9 185.9L143.9 339.9C138.4 345.4 129.6 345.4 124.1 339.9zM88 424H136V460.3L71.5 471.6 40.4 440.5 51.7 376H88V424z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/pencil-alt.js
// module id = GVUG
// module chunks = 144